module.exports = __webpack_public_path__ + "static/media/icons_Bilan Paralysie cérébrale 2-18 ans.10726b10.svg";